import * as React from 'react'
import CountUp from 'react-countup'
import { PurchaseOption } from '../../Checkout/lib/purchase_option'
import { MembershipPlanDiscountBreakdown } from "../../MembershipPlanCards/components/MembershipPlanDiscountBreakdown";

interface IProps {
  purchaseOption: PurchaseOption
  ctaEnabled: boolean
}

interface IState {
  previousPrice: number
  currentPrice: number
}

export class MembershipPlanPrice extends React.Component<IProps, IState> {
  public static getDerivedStateFromProps(props: IProps, state: IState): Partial<IState> | null {
    const { purchaseOption, ctaEnabled } = props
    const newPrice = MembershipPlanPrice.calculateYourPrice(purchaseOption, ctaEnabled)

    return {
      previousPrice: state.currentPrice,
      currentPrice: newPrice,
    }
  }

  public static calculateYourPrice(purchaseOption: PurchaseOption, ctaEnabled: boolean): number {
    return purchaseOption.actualPrice()
  }

  public constructor(props: IProps) {
    super(props)

    this.state = {
      previousPrice: this.yourPrice(),
      currentPrice: this.yourPrice(),
    }
  }

  public render() {
    return (
      <div className="membership-pricing">
        {this.renderFullPriceBlock()}
        {this.renderYourPriceBlock()}
        {this.renderPriceBreakdown()}
      </div>
    )
  }

  private renderFullPriceBlock() {
    const { purchaseOption } = this.props
    const { fullPrice, price } = purchaseOption.paymentOption

    if (price === fullPrice) { return null }

    return (
      <span className="full-price">
        <sup className="currency">$</sup>
        <span className="amount">{purchaseOption.fullPrice()}</span>
        <sub className="term">&nbsp;/&nbsp;{purchaseOption.paymentFrequencyLabel()}</sub>
      </span>
    )
  }

  private renderYourPriceBlock() {
    const { previousPrice } = this.state
    const { purchaseOption } = this.props

    return (
      <span className="price">
        <span className="currency">$</span>
        <CountUp
          start={previousPrice}
          end={this.yourPrice()}
          duration={0.75}
        />
        <sub className="term">&nbsp;/&nbsp;{purchaseOption.paymentFrequencyLabel()}</sub>
      </span>
    )
  }

  private renderPriceBreakdown() {
    const { purchaseOption } = this.props
    const {
      membershipPlan: { name: planName },
      paymentOption: { priceBreakdown: priceDetails, fullPrice, price },
    } = purchaseOption

    if (price === fullPrice) { return null }

    return (
      <MembershipPlanDiscountBreakdown
        planName={planName}
        priceDetails={priceDetails}
        paymentDetails={purchaseOption.paymentDetails}
      />
    )
  }

  private yourPrice(): number {
    const { purchaseOption, ctaEnabled } = this.props

    return MembershipPlanPrice.calculateYourPrice(purchaseOption, ctaEnabled)
  }
}
